@Service(
    'ib-MmB-services-module', [
        'CommonsGenericProxy',
        'MmBAppConstants',
        'CommonsNewHttpUtilsErrorService'
    ], [])
export class DigitalMenuStatusService {
    constructor (
        private CommonsGenericProxy: CommonsGenericProxy,
        private MmBAppConstants: MmBAppConstants,
        private CommonsNewHttpUtilsErrorService: CommonsNewHttpUtilsErrorService
    ) {}

    getDigitalMenuStatus = (flowId: string) => {
        return new Promise((resolve, reject) => {
            const endpoint = this.MmBAppConstants.DEFAULT_ENDPOINTS.digitalMenuStatusURI;
            this.CommonsGenericProxy.postGeneric(endpoint, {'flowId': flowId}).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    this.CommonsNewHttpUtilsErrorService.controlError(error, reject);
                });
        });
    };
}